import { render, staticRenderFns } from "./SideRow.vue?vue&type=template&id=27593627&"
import script from "./SideRow.vue?vue&type=script&lang=js&"
export * from "./SideRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports